import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CashDeskCoreRxDbService } from '../@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-rxdb.service';
import { ApiCluAgentService } from './api-clu-agent.service';
import { catchError, lastValueFrom, throwError } from 'rxjs';
import { GetNetworkErrorMessage } from '../utils/network-error-handler';
import { CLU_TICKET_STATUS, CluTickItem } from '../@clu-fe/apps/m-cashdesk/@models/clutick.model';
import { aggregateBy, process } from '@progress/kendo-data-query';
import { AuthService } from '../@auth/auth.service';
import { AuthSessionDto, AuthSessionDtoFO, REMDOCS_TYPE_DOCUMENT, REMDOCS_TYPE_IMPRESSION, TYPE_MODELE_IMPRESSION } from '../app.models';
import { RxCluTickDuplicataDocumentType } from '../@clu-fe/apps/m-cashdesk/@schemas/clu_tickduplicata.schema';
import { ApiService } from './api.service';
import { DbmPModeleImpression_CashDesk } from '../@clu-be/apps/p-cashdesk/p-cashdesk-modeles-impressions/connector-p-cashdesk-modeles-impressions.service';
import { CASHDESK_ZCLOSING_PARAMS, CASHDESK_ZCLOSING_RG_BILAN_ITEM } from '../@clu-fe/apps/m-cashdesk/cashdesk/@modals/md-cashdesk-closing-z/md-closing-z-process/md-closing-z-process.model';
import { RemDocsCoreRxDbService } from '../@clu-fe/apps/m-remdocs/@services/m-remdocs-core-rxdb.service';
import { CluDocItem } from '../@clu-fe/apps/m-remdocs/@models/cludoc.model';
import { CluBilanTaxeItem } from '../@clu-fe/apps/m-remdocs/m-remdocs.model';
import { RxFArticleCollection, RxFArticleDocument } from '../@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-rxdb';
import { TauriService } from './tauri/tauri.service';
import { CluCashOpItem } from '../@clu-fe/apps/m-cashdesk/@models/clucashops.model';
import moment from 'moment';

@Injectable()
export class CashdeskDevicesPrinterService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private _authService: AuthService,
        private _apiCluAgentService: ApiCluAgentService,
        private _cashDeskRxDbService : CashDeskCoreRxDbService,
        private _remDocsRxDbService : RemDocsCoreRxDbService,
        private _tauriService: TauriService
    ) {
    }

    // STANDARD PRINTER ******************************************************
    doTestPrinterAction_StandardPrinter(printerId: string, modele: any) {
        return new Promise<void>(async (resolve, reject) => {
            if (!this._apiCluAgentService.endPoints) { reject("Configuration Agent invalide"); }
            try {
                await lastValueFrom(this._httpClient.post<void>(this._apiCluAgentService.endPoints!.doTestPrinterAction_StandardPrinter, { PRINTER_ID: printerId, MODELE_IMPRESSION: modele }));
                resolve();
            } catch(error) {
                reject(GetNetworkErrorMessage(error));
            }
        });
    }

    doPrintDocumentAction_StandardPrinter(params: {
        MODELE_IMPRESSION: any,
        CONFIG: any,
        NB_COPIES?: number,
        CURRENT_COUNT_IMPRESSIONS?: number,
        PRINTER_ID?: string,
        IS_TEST_PRINT?: boolean
    }) {
        return new Promise<void>(async (resolve, reject) => {
            if (!this._apiCluAgentService.endPoints) { reject("Configuration Agent invalide"); }
            try {
                const dto = Object.assign({ DATE_PRINT: moment().local().format("YYYY-MM-DD HH:mm:ss") }, params);
                await lastValueFrom(this._httpClient.post<void>(this._apiCluAgentService.endPoints!.doPrintDocumentAction_StandardPrinter, dto));
                resolve();
            } catch(error) {
                reject(GetNetworkErrorMessage(error, 'Erreur lors de l\'impression: Veuillez vérifier la configuration de l\'AGENT CAURIS LINKUP'));
            }
        });
    }
    // ************************************************************

    // PRINTER ******************************************************
    doTestPrinterAction_SerialPrinter(printerId: string, modele: any) {
        return new Promise<void>(async (resolve, reject) => {
            if (!this._apiCluAgentService.endPoints) { reject("Configuration Agent invalide"); }
            try {
                await lastValueFrom(this._httpClient.post<void>(this._apiCluAgentService.endPoints!.doTestPrinterAction_SerialPrinter, { PRINTER_ID: printerId, MODELE_IMPRESSION: modele }));
                resolve();
            } catch(error) {
                reject(GetNetworkErrorMessage(error));
            }
        });
    }

    doPrintDocumentAction_SerialPrinter(params: {
        MODELE_IMPRESSION: any,
        CONFIG: any,
        NB_COPIES?: number,
        CURRENT_COUNT_IMPRESSIONS?: number,
        PRINTER_ID?: string,
        IS_TEST_PRINT?: boolean
    }) {
        return new Promise<void>(async (resolve, reject) => {
            if (!this._apiCluAgentService.endPoints) { reject("Configuration Agent invalide"); }
            try {
                const dto = Object.assign({ DATE_PRINT: moment().local().format("YYYY-MM-DD HH:mm:ss") }, params);
                await lastValueFrom(this._httpClient.post<void>(this._apiCluAgentService.endPoints!.doPrintDocumentAction_SerialPrinter, dto));
                resolve();
            } catch(error) {
                reject(GetNetworkErrorMessage(error, 'Erreur lors de l\'impression du ticket: Veuillez vérifier la configuration de l\'AGENT CAURIS LINKUP'));
            }
        });
    }

    doOpenCashdeskAction_SerialPrinter(printerId?: string) {
        return new Promise<void>(async (resolve, reject) => {
            if (!this._apiCluAgentService.endPoints) { reject("Configuration Agent invalide"); }
            try {
                await lastValueFrom(this._httpClient.post<void>(this._apiCluAgentService.endPoints!.doOpenCashdeskAction_SerialPrinter, { PRINTER_ID: printerId }));
                resolve();
            } catch(error) {
                reject(GetNetworkErrorMessage(error));
            }
        });
    }
    // ************************************************************



    // PRINT UTILS ******************************************************

    async runQuery_doGetMouvementsCaisseItems() : Promise<CluCashOpItem[]> {
        let _opItems : CluCashOpItem[] = [];
        const query_CASHOPS = this._cashDeskRxDbService.db.clucashops.find({
            selector: {
                $and : [
                    { MD_CAISSE_SESSION : { $eq: localStorage.getItem('LS_FE_AUTH_CASHDESK_SESSION') } }
                ]
            },
            sort: []
        });
        let CASHOPS_ITEMS = await query_CASHOPS.exec();
        for (const item of CASHOPS_ITEMS) {
            let _opItem = new CluCashOpItem();
            _opItem.FROM_RXDOCUMENT(item);
            _opItems.push(_opItem);
        }
        return _opItems;
    }

    async runQuery_doGetRemdocsReglementsDocumentsItems() : Promise<any[]> {
        const query_CASHOPS = this._cashDeskRxDbService.db.remdocs_reglements_documents.find({
            selector: {
                $and : [
                    { MD_CAISSE_SESSION : { $eq: localStorage.getItem('LS_FE_AUTH_CASHDESK_SESSION') } }
                ]
            },
            sort: []
        });
        const dbItems = await query_CASHOPS.exec();

        let items: any[] = [];
        for (const dbItem of dbItems) {
          let reglementDetails: any = null;
          if (dbItem.DOMAINE == 0 && !!dbItem.VENTES) {
            try { reglementDetails = JSON.parse(dbItem.VENTES); } catch (error) { }
          } else if (dbItem.DOMAINE == 1 && !!dbItem.ACHATS) {
            try { reglementDetails = JSON.parse(dbItem.ACHATS); } catch (error) { }
          }
          if (reglementDetails) {
            items.push({
              DOMAINE: dbItem.DOMAINE,
              MD_CAISSE_SESSION: dbItem.MD_CAISSE_SESSION,
              PK_ID: dbItem.PK_ID,
              CT_NUM: dbItem.CT_NUM,
              CT_INTITULE: dbItem.CT_INTITULE,
              ...reglementDetails
            });
          }
        }
        return items;
    }

    async runQuery_doGetRemdocsReglementsClientsItems() : Promise<any[]> {
        const query_CASHOPS = this._cashDeskRxDbService.db.remdocs_reglements_clients.find({
            selector: {
                $and : [
                    { MD_CAISSE_SESSION : { $eq: localStorage.getItem('LS_FE_AUTH_CASHDESK_SESSION') } }
                ]
            },
            sort: []
        });
        const dbItems = await query_CASHOPS.exec();
        console.log("REGLEMENT CLIENTS - DB ITEMS", dbItems);

        let items: any[] = [];
        for (const dbItem of dbItems) {
          let reglementDetails: any = null;
          if (dbItem.DOMAINE == 0 && !!dbItem.VENTES) {
            try { reglementDetails = JSON.parse(dbItem.VENTES); } catch (error) { }
          } else if (dbItem.DOMAINE == 1 && !!dbItem.ACHATS) {
            try { reglementDetails = JSON.parse(dbItem.ACHATS); } catch (error) { }
          }
          if (reglementDetails) {
            items.push({
              DOMAINE: dbItem.DOMAINE,
              MD_CAISSE_SESSION: dbItem.MD_CAISSE_SESSION,
              PK_ID: dbItem.PK_ID,
              CT_NUM: dbItem.CT_NUM,
              CT_INTITULE: dbItem.CT_INTITULE,
              ...reglementDetails
            });
          }
        }
        return items;
    }

    async runQuery_doGetRemdocsAcomptesClientsItems() : Promise<any[]> {
        const query_CASHOPS = this._cashDeskRxDbService.db.remdocs_acomptes_clients.find({
            selector: {
                $and : [
                    { MD_CAISSE_SESSION : { $eq: localStorage.getItem('LS_FE_AUTH_CASHDESK_SESSION') } }
                ]
            },
            sort: []
        });
        const dbItems = await query_CASHOPS.exec();
        console.log("ACOMPTE CLIENTS - DB ITEMS", dbItems);

        let items: any[] = [];
        for (const dbItem of dbItems) {
          let reglementDetails: any = null;
          if (dbItem.DOMAINE == 0 && !!dbItem.VENTES) {
            try { reglementDetails = JSON.parse(dbItem.VENTES); } catch (error) { }
          } else if (dbItem.DOMAINE == 1 && !!dbItem.ACHATS) {
            try { reglementDetails = JSON.parse(dbItem.ACHATS); } catch (error) { }
          }
          if (reglementDetails) {
            items.push({
              DOMAINE: dbItem.DOMAINE,
              MD_CAISSE_SESSION: dbItem.MD_CAISSE_SESSION,
              PK_ID: dbItem.PK_ID,
              CT_NUM: dbItem.CT_NUM,
              CT_INTITULE: dbItem.CT_INTITULE,
              ...reglementDetails
            });
          }
        }
        return items;
    }

    async runQuery_doGetCluGiftCardItems() : Promise<any[]> {
        const query_CASHOPS = this._cashDeskRxDbService.db.clugiftcard.find({
            selector: {
                $and : [
                    { MD_CAISSE_SESSION : { $eq: localStorage.getItem('LS_FE_AUTH_CASHDESK_SESSION') } }
                ]
            },
            sort: []
        });
        const dbItems = await query_CASHOPS.exec();
        return dbItems;
    }

    async doGetPrintXCaisseInfos(closingParams: CASHDESK_ZCLOSING_PARAMS) : Promise<any> {
        const pDossier: any = (await this._cashDeskRxDbService.db.pdossier.findOne().exec() as any).get();
        let ticketsItems: any[] = [];
        let pDevice: any = null;
        if (this._tauriService.isTauri) {
            pDevice = await this._tauriService.doGetPDeviceItemByCaissegidAction(localStorage.getItem('LS_FE_AUTH_CASHDESK_GID')!);
            ticketsItems = await this._tauriService.doGetCluTickEntetesAction({
                MD_CAISSE: pDevice.CAISSEGID,
                MD_CAISSE_SESSION: pDevice.CAISSE_SESSION,
            });
        } else {
            pDevice = (await this._cashDeskRxDbService.db.pdevice.findOne({
                selector: { "CAISSEGID": { "$eq": localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') } },
                sort: []
            }).exec() as any).get();
            ticketsItems = await this._cashDeskRxDbService.db.clutickentete.find({
                selector: {
                    $and : [
                        { MD_CAISSE : { $eq: pDevice.CAISSEGID } },
                        { MD_CAISSE_SESSION : { $eq: pDevice.CAISSE_SESSION } },
                        //{ MD_CAISSIERGID : { $eq: '432712bf-33c3-4df9-89de-d90512c1659b' } }
                    ]
                },
                sort: []
            }).exec();
        }
        const cashopItems = await this._cashDeskRxDbService.db.clucashops.find({
            selector: {
                $and : [
                    { MD_CAISSE : { $eq: pDevice.CAISSEGID } },
                    { MD_CAISSE_SESSION : { $eq: pDevice.CAISSE_SESSION } },
                ]
            },
            sort: []
        }).exec();
        const TICKENTETE_ITEMS: CluTickItem[] = [];
        const TICKENTETE_CANCELED: CluTickItem[] = [];
        for (var i in ticketsItems) {
            const ticket = ticketsItems[i];
            const cluTicketItem = await this.runQuery_doGetCluTickItem(ticket.DO_PIECE_INTERNAL);
            if (cluTicketItem.ENTETE.ZTICKET_STATUS == CLU_TICKET_STATUS.TICKET_CLOSED) {
                TICKENTETE_ITEMS.push(cluTicketItem);
            } else if (cluTicketItem.ENTETE.ZTICKET_STATUS == CLU_TICKET_STATUS.TICKET_CANCELLED) {
                TICKENTETE_CANCELED.push(cluTicketItem);
            }
        }

        const reglements = await this.GetXCaisseInfosReglements(TICKENTETE_ITEMS, closingParams.RG_BILAN_ITEMS);
        const infosCaisse = await this.GetXCaisseInfosCaisse(pDevice, cashopItems, TICKENTETE_ITEMS, TICKENTETE_CANCELED, closingParams);
        infosCaisse.TOTAL_REGLEMENTS_REEL = reglements.reduce((n, { RG_MONTANT_REEL }) => n + RG_MONTANT_REEL!, 0);

        const mouvementsCaisse = await this.runQuery_doGetMouvementsCaisseItems();
        const remDocsReglementsDocuments = await this.runQuery_doGetRemdocsReglementsDocumentsItems();
        const remDocsReglementsClients = await this.runQuery_doGetRemdocsReglementsClientsItems();
        const remDocsAcomptesClients = await this.runQuery_doGetRemdocsAcomptesClientsItems();
        const cluGiftCardItems = await this.runQuery_doGetCluGiftCardItems();
        const cluGiftCardsTotalTTCInit = cluGiftCardItems.reduce((n, { C_TOTAL_TTC_INIT }) => n + C_TOTAL_TTC_INIT!, 0);

        return {
            SOCIETE: [this.GetInfosSociete(pDossier)],
            CAISSE: [infosCaisse],
            CASHDESK_REMDOCS: [
              {
                TOTAL_CRD_REGLEMENTS_DOCS_SAGE: closingParams.TOTAL_CRD_REGLEMENTS_DOCS_SAGE,
                TOTAL_CRD_ACOMPTES_DOCS_SAGE: closingParams.TOTAL_CRD_ACOMPTES_DOCS_SAGE
              },
            ],
            GIFTCARD: cluGiftCardItems.map(m => {
              return {
                CARTE_NUM: m.CARTE_NUM,
                CARTE_DESIGNATION: m.CARTE_DESIGNATION,
                CARTE_DATE_CREATION: m.CARTE_DATE_CREATION,
                DATE_DEBUT: m.DATE_DEBUT,
                DATE_EXP: m.DATE_EXP,
                DO_TIERS_SAGE: m.DO_TIERS_SAGE,
                CT_INTITULE_SAGE: m.CT_INTITULE_SAGE,
                C_TOTAL_TTC_CURRENT: m.C_TOTAL_TTC_CURRENT,
                C_TOTAL_TTC_INIT: m.C_TOTAL_TTC_INIT,
                MD_CAISSIERGID: m.MD_CAISSIERGID,
                MD_CAISSIER: m.MD_CAISSIER,
                TOTAL_GIFTCARDS_TTC_INIT: cluGiftCardsTotalTTCInit
              };
            }),
            MOUVEMENTS_CAISSE: mouvementsCaisse.map(m => {
              return {
                  CG_NUM: m.CG_NUM,
                  CG_NUM_J: m.CG_NUM_J,
                  EC_CATEGORIE: m.EC_CATEGORIE,
                  EC_CATEGORIE_LIB: m.EC_CATEGORIE_LIB,
                  EC_DATE_ECR_V: m.EC_DATE_ECR_V,
                  EC_DATE_V: m.EC_DATE_V,
                  EC_HEURE: m.EC_HEURE,
                  EC_FLAG: m.EC_FLAG,
                  EC_INTITULE: m.EC_INTITULE,
                  EC_MONTANT: m.EC_MONTANT,
                  EC_MT_IN: m.EC_MT_IN,
                  EC_MT_OUT: m.EC_MT_OUT,
                  EC_NATURE: m.EC_NATURE,
                  EC_NATURE_LIB: m.EC_NATURE_LIB,
                  EC_REFERENCE: m.EC_REFERENCE,
                  EC_SENS: m.EC_SENS,
                  JO_NUM: m.JO_NUM,
                  MD_CAISSE: m.MD_CAISSE,
                  MD_CAISSE_LIB: m.MD_CAISSE_LIB,
                  MD_CAISSE_SESSION: m.MD_CAISSE_SESSION,
                  MD_CAISSIER: m.MD_CAISSIER,
                  MD_CAISSIER_LIB: m.MD_CAISSIER_LIB,
                  MD_DATE_CREATION: m.MD_DATE_CREATION,
                  N_REGLEMENT: m.N_REGLEMENT,
                  N_REGLEMENTLIB: m.N_REGLEMENTLIB,
                  N_ANALYTIQUE: !!m.ANA_ITEMS && m.ANA_ITEMS.length > 0 ? m.ANA_ITEMS[0].N_ANALYTIQUE : null,
                  N_ANALYTIQUELIB: !!m.ANA_ITEMS && m.ANA_ITEMS.length > 0 ? m.ANA_ITEMS[0].N_ANALYTIQUELIB : null,
              };
            }),
            REMDOCS_REGLEMENTS_DOCUMENTS: remDocsReglementsDocuments.map((r: any) => {
              return {
                RG_REFERENCE: r.RG_REFERENCE,
                RG_LIBELLE: r.RG_LIBELLE,
                RG_MONTANT: r.RG_MONTANT,
                RG_DATE: r.RG_DATE,
                N_REGLEMENT: r.N_REGLEMENT,
                N_REGLEMENTLIB: r.N_REGLEMENTLIB,
                DO_PIECE: r.DO_PIECE,
                CT_NUM: r.CT_NUM,
                CT_INTITULE: r.CT_INTITULE,
                N_DEVISELIB: r.N_DEVISELIB,
                RG_MONTANTDEV: r.RG_MONTANTDEV,
                RG_COURS: r.RG_COURS,
                JO_NUM: r.JO_NUM,
              };
            }),
            REMDOCS_REGLEMENTS_CLIENTS: remDocsReglementsClients.map((r: any) => {
              return {
                RG_REFERENCE: r.RG_REFERENCE,
                RG_LIBELLE: r.RG_LIBELLE,
                RG_MONTANT: r.RG_MONTANT,
                RG_DATE: r.RG_DATE,
                N_REGLEMENT: r.N_REGLEMENT,
                N_REGLEMENTLIB: r.N_REGLEMENTLIB,
                DO_PIECE: r.DO_PIECE,
                CT_NUM: r.CT_NUM,
                CT_INTITULE: r.CT_INTITULE,
                N_DEVISELIB: r.N_DEVISELIB,
                RG_MONTANTDEV: r.RG_MONTANTDEV,
                RG_COURS: r.RG_COURS,
                JO_NUM: r.JO_NUM,
              };
            }),
            REMDOCS_ACOMPTES_CLIENTS: remDocsAcomptesClients.map((r: any) => {
              return {
                CT_NUM: r.CT_NUM,
                CT_INTITULE: r.CT_INTITULE,
                DO_PIECE: r.DO_PIECE,
                DR_LIBELLE: r.DR_LIBELLE,
                DR_MONTANT: r.DR_MONTANT,
                DR_DATE: r.DR_DATE,
                JO_NUM: r.JO_NUM,
                N_REGLEMENT: r.N_REGLEMENT,
                N_REGLEMENTLIB: r.N_REGLEMENTLIB,
              };
            }),
            FAMILLES_ARTICLES: closingParams.FAMILLES_BILAN_ITEMS ?? [],
            TICKETS: TICKENTETE_ITEMS.map(t => {
              return {
                CA_INTITULE: t.ENTETE.CA_INTITULE,
                CA_NUM: t.ENTETE.CA_NUM,
                CO_LIB: t.ENTETE.CO_LIB,
                CO_NO: t.ENTETE.CO_NO,
                CT_INTITULE: t.ENTETE.CT_INTITULE,
                DE_INTITULE: t.ENTETE.DE_INTITULE,
                DE_NO: t.ENTETE.DE_NO,
                DO_COORD02: t.ENTETE.DO_COORD02,
                DO_COORD03: t.ENTETE.DO_COORD03,
                DO_COORD04: t.ENTETE.DO_COORD04,
                DO_DEVISELIB: t.ENTETE.DO_DEVISELIB,
                DO_MONTANTREGLE: t.ENTETE.DO_MONTANTREGLE,
                DO_MONTANTREGLE_F: t.ENTETE.DO_MONTANTREGLE_F,
                DO_NETAPAYER: t.ENTETE.DO_NETAPAYER,
                DO_PIECE_INTERNAL: t.ENTETE.DO_PIECE_INTERNAL,
                DO_REF: t.ENTETE.DO_REF,
                DO_REMISE_MT: t.ENTETE.DO_REMISE_MT,
                DO_RG_ESP_RECU_TOT: t.ENTETE.DO_RG_ESP_RECU_TOT,
                DO_RG_ESP_RENDU_TOT: t.ENTETE.DO_RG_ESP_RENDU_TOT,
                DO_RG_MONTANTECART: t.ENTETE.DO_RG_MONTANTECART,
                DO_SOLDETTC: t.ENTETE.DO_SOLDETTC,
                DO_SOUCHELIB: t.ENTETE.DO_SOUCHELIB,
                DO_TAXES: t.ENTETE.DO_TAXES,
                DO_TIERS: t.ENTETE.DO_TIERS,
                DO_TOTALHT: t.ENTETE.DO_TOTALHT,
                DO_TOTALHTNET: t.ENTETE.DO_TOTALHTNET,
                DO_TOTALTTC: t.ENTETE.DO_TOTALTTC,
                DO_TYPE_OP: t.ENTETE.DO_TYPE_OP,
                MD_CAISSE_LIB: t.ENTETE.MD_CAISSE_LIB,
                MD_CAISSIER: t.ENTETE.MD_CAISSIER,
                MD_CAISSIER_LIB: t.ENTETE.MD_CAISSIER_LIB,
                MD_DATE_CREATION: t.ENTETE.MD_DATE_CREATION,
              };
            }),
            REGLEMENTS: reglements,
            TAXES: await this.GetInfosTaxes(TICKENTETE_ITEMS),
            CAISSIERS: this.GetXCaisseInfosCaissiers(TICKENTETE_ITEMS),
        };
    }

    private async GetXCaisseInfosReglements(tickets: CluTickItem[], rgBilanItems: CASHDESK_ZCLOSING_RG_BILAN_ITEM[]) {
        const query_REGLEMENTS = Array.prototype.concat.apply([], tickets.map(t => t.REGLEMENTS).map(r => r));
        const modeReglements = await this._cashDeskRxDbService.db.preglement.find().exec();
        let infosReglements: any[] = [];

        modeReglements.forEach(r => {
            infosReglements.push({
                CBINDICE: r.CBINDICE,
                R_INTITULE: r.R_INTITULE,
                RG_MONTANT: query_REGLEMENTS.filter((i: any) => i.N_REGLEMENT == r.CBINDICE).reduce((n, { RG_MONTANT }) => n + RG_MONTANT!, 0)
            });
        });

        const otherReglements = [].concat.apply([], tickets.map((t: any) => t.REGLEMENTS)).filter((r: any) => infosReglements.findIndex((i: any) => i.CBINDICE == r.N_REGLEMENT) == -1);
        const otherModeReglements: any[] = [];
        otherReglements.forEach((r: any) => {
            if (otherModeReglements.findIndex((m: any) => m.CBINDICE == r.N_REGLEMENT) == -1) {
                otherModeReglements.push({
                    CBINDICE: r.N_REGLEMENT,
                    R_INTITULE: r.N_REGLEMENTLIB,
                    RG_MONTANT: otherReglements.filter((i: any) => i.N_REGLEMENT == r.N_REGLEMENT).reduce((n, { RG_MONTANT }) => n + RG_MONTANT!, 0)
                })
            }
        });

        infosReglements = infosReglements.concat(otherModeReglements);

        infosReglements.forEach((r: any, index: number, infos: any[]) => {
            const rgBilanItem = rgBilanItems.find((i: any) => i.N_REGLEMENT == r.CBINDICE);
            infos[index].RG_MONTANT_REEL = !!rgBilanItem ? rgBilanItem.RG_SOLDE : infos[index].RG_MONTANT;
        });

        return infosReglements.filter((r: any) => r.RG_MONTANT != 0);
    }

    private async runQuery_doGetCluTickItem(DO_PIECE_INTERNAL : string) : Promise<CluTickItem> {
        if (this._tauriService.isTauri) {
            const cluTickItemRaw = await this._tauriService.doGetCluTickItemAction(DO_PIECE_INTERNAL);
            const cluTickItem = Object.assign(new CluTickItem(), cluTickItemRaw);
            return cluTickItem;
        } else {
            const query_ENTETE = this._cashDeskRxDbService.db.clutickentete.findOne({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: []
            });
            const query_LIGNES = this._cashDeskRxDbService.db.clutickligne.find({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: [{ DL_LIGNE: 'asc' }]
            });
            const query_REGLEMENTS = this._cashDeskRxDbService.db.clutickreglement.find({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: []
            });
            let ENTETE = await query_ENTETE.exec();
            if (ENTETE == undefined) throw Error('Le document ' + DO_PIECE_INTERNAL +  ' ne semble pas exister.');
            let LIGNES = await query_LIGNES.exec();
            let REGLEMENTS = await query_REGLEMENTS.exec();
            const cluTickItem = new CluTickItem();
            cluTickItem.ENTETE = JSON.parse(JSON.stringify(ENTETE));
            cluTickItem.LIGNES = JSON.parse(JSON.stringify(LIGNES));
            cluTickItem.REGLEMENTS = JSON.parse(JSON.stringify(REGLEMENTS));
            return cluTickItem;
        }
    }

    private GetInfosSociete(pDossier: any) {
        return {
            D_RAISONSOC: pDossier.D_RAISONSOC,
            D_PROFESSION: pDossier.D_PROFESSION,
            D_ADRESSE: pDossier.D_ADRESSE,
            D_COMPLEMENT: pDossier.D_COMPLEMENT,
            D_CODEPOSTAL: pDossier.D_CODEPOSTAL,
            D_VILLE: pDossier.D_VILLE,
            D_CODEREGION: pDossier.D_CODEREGION,
            D_PAYS: pDossier.D_PAYS,
            D_EMAIL: pDossier.D_EMAIL,
            D_TELEPHONE: pDossier.D_TELEPHONE,
            D_TELECOPIE: pDossier.D_TELECOPIE,
            D_SITE: pDossier.D_SITE,
            D_SIRET: pDossier.D_SIRET,
            D_APE: pDossier.D_APE,
            D_IDENTIFIANT: pDossier.D_IDENTIFIANT,
            D_RCS: pDossier.D_RCS,
        };
    }

    private async GetXCaisseInfosCaisse(pDevice: any, cashopItems: any[], closedTickets: CluTickItem[], canceledTickers: CluTickItem[], closingParams: CASHDESK_ZCLOSING_PARAMS) {
        const result = aggregateBy(closedTickets.map(t => t.ENTETE), [
            { field : 'DO_TOTALHT', aggregate : 'sum' },
            { field : 'DO_TOTALTTC', aggregate : 'sum' },
            { field : 'DO_TOTALTTC', aggregate : 'average' },
            { field : 'DO_MONTANTREGLE', aggregate : 'sum' },
            { field : 'DO_REMISEMT', aggregate : 'sum' },
            { field : 'DO_TAXES', aggregate : 'sum' },
        ]);
        const authenticatedSession = this._authService.authenticatedSession$.value;

        const DO_MONTANTREGLE = result['DO_MONTANTREGLE']?.sum || 0;
        const ENCAISSEMENTS = cashopItems.filter(m=> m.EC_SENS == '0').reduce((n, { EC_MONTANT }) => n + EC_MONTANT!, 0);
        const DECAISSEMENTS = cashopItems.filter(m=> m.EC_SENS == '1').reduce((n, { EC_MONTANT }) => n + EC_MONTANT!, 0);
        const SOLDE_TH = pDevice.CAISSE_SESSION_OUVERTURE_FOND_CAISSE + DO_MONTANTREGLE + ENCAISSEMENTS - DECAISSEMENTS;
        const SOLDE_TH_HORS_FOND_CAISSE = SOLDE_TH - pDevice.CAISSE_SESSION_OUVERTURE_FOND_CAISSE;

        const SOLDE_REEL = closingParams.DECOMPTE_FOND_CAISSE + closingParams.DECOMPTE_TOTAL;
        const SOLDE_REEL_HORS_FOND_CAISSE = SOLDE_REEL - closingParams.DECOMPTE_FOND_CAISSE;

        let DATE_OUVERTURE_CAISSE_LOCAL = moment.utc(pDevice.CAISSE_SESSION_OUVERTURE).utcOffset(pDevice.CAISSE_SESSION_OUVERTURE_FH_UTC * 60);
        let DATE_CLOTURE_CAISSE_LOCAL = moment.utc(pDevice.CAISSE_SESSION_CLOTURE).utcOffset(pDevice.CAISSE_SESSION_CLOTURE_FH_UTC * 60);
        if (!DATE_OUVERTURE_CAISSE_LOCAL.isValid()) DATE_OUVERTURE_CAISSE_LOCAL = moment(pDevice.CAISSE_SESSION_OUVERTURE);
        if (!DATE_CLOTURE_CAISSE_LOCAL.isValid()) DATE_CLOTURE_CAISSE_LOCAL = moment(pDevice.CAISSE_SESSION_CLOTURE);


        return {
            CAISSEGID: pDevice.CAISSEGID,
            NOM_CAISSE: pDevice.C_DENOMINATION,
            NOM_CAISSIER: `${authenticatedSession?.NOM} ${authenticatedSession?.PRENOM}`,
            DATE_OUVERTURE_CAISSE: DATE_OUVERTURE_CAISSE_LOCAL.isValid() ? DATE_OUVERTURE_CAISSE_LOCAL.format("YYYY-MM-DD HH:mm:ss") : null,
            DATE_CLOTURE_CAISSE: DATE_CLOTURE_CAISSE_LOCAL.isValid() ? DATE_CLOTURE_CAISSE_LOCAL.format("YYYY-MM-DD HH:mm:ss") : null,
            NOMBRE_TICKETS: closedTickets.length,
            NOMBRE_TICKETS_ANNULES: canceledTickers.length,
            TOTAL_CA_HT: result['DO_TOTALHT']?.sum || 0,
            TOTAL_CA_TTC: result['DO_TOTALTTC']?.sum || 0,
            AVG_TOTAL_TTC: result['DO_TOTALTTC']?.average || 0,
            TOTAL_REMISES: result['DO_REMISEMT']?.sum || 0,
            TOTAL_TAXES: result['DO_TAXES']?.sum || 0,
            TOTAL_REGLEMENTS: DO_MONTANTREGLE,
            CAISSE_SESSION_OUVERTURE_FOND_CAISSE: pDevice.CAISSE_SESSION_OUVERTURE_FOND_CAISSE,
            CAISSE_SESSION_CLOTURE_SOLDE_CAISSE: SOLDE_TH,
            CAISSE_SESSION_CLOTURE_SOLDE_THEORIQUE: SOLDE_TH_HORS_FOND_CAISSE,
            ENCAISSEMENTS: ENCAISSEMENTS,
            DECAISSEMENTS: DECAISSEMENTS,

            TOTAL_REGLEMENTS_REEL: closingParams.DECOMPTE_TOTAL,
            CAISSE_SESSION_OUVERTURE_FOND_CAISSE_REEL: closingParams.DECOMPTE_FOND_CAISSE,
            CAISSE_SESSION_CLOTURE_SOLDE_CAISSE_REEL: SOLDE_REEL,
            CAISSE_SESSION_CLOTURE_SOLDE_CAISSE_REEL_HORS_FOND: SOLDE_REEL_HORS_FOND_CAISSE,
            CLOSING_COMMENT: closingParams.CLOSING_COMMENT,
            CLOSING_ECART: closingParams.CLOSING_ECART,
        };
    }

    private GetXCaisseInfosCaissiers(tickets: CluTickItem[]) {
        const result = process<any>(tickets.map(t => t.ENTETE), { group: [{ field: "MD_CAISSIER_LIB" }] });
        const infosCaissiers: any = [];
        result.data.forEach(r => {
            const result = aggregateBy(r.items.filter((i: any) => i.MD_CAISSIER_LIB == r.value), [
                { field : 'DO_TOTALHT', aggregate : 'sum' },
                { field : 'DO_TOTALTTC', aggregate : 'sum' },
                { field : 'DO_TOTALTTC', aggregate : 'average' },
                { field : 'DO_MONTANTREGLE', aggregate : 'sum' }
            ]);
            infosCaissiers.push({
                MD_CAISSIER_LIB: r.value,
                NB: tickets.length,
                DO_TOTALHT: !!result['DO_TOTALHT'] ? result['DO_TOTALHT'].sum : 0,
                DO_TOTALTTC: !!result['DO_TOTALTTC'] ? result['DO_TOTALTTC'].sum : 0,
                DO_TOTALTTC_AVG: !!result['DO_TOTALTTC'] ? result['DO_TOTALTTC'].average : 0,
                DO_MONTANTREGLE: !!result['DO_MONTANTREGLE'] ? result['DO_MONTANTREGLE'].sum : 0,
            });
        });

        return infosCaissiers;
    }

    private async GetInfosTaxes(tickets: CluTickItem[]) {
        const infosTaxes: any = [];
        const pTaxes = await this._cashDeskRxDbService.db.ftaxe.find({ selector: { }, sort: [] }).exec();
        tickets.filter(ticket => !!ticket.GET_BILAN_TAXES).forEach(ticket => {
            const taxes = ticket.GET_BILAN_TAXES(pTaxes);
            taxes.forEach(taxe => {
                let infoTaxeIndex = infosTaxes.findIndex((infoTaxe: any) => infoTaxe.DL_CODETAXE == taxe.DL_CODETAXE);
                if (infoTaxeIndex === -1) {
                    if (!!(ticket as any).TAXES) {
                        infoTaxeIndex = (ticket as any).TAXES.findIndex((t: any) => t.DL_CODETAXE == taxe.DL_CODETAXE);
                        if (infoTaxeIndex > -1) {
                            taxe.DL_TAXELIB = (ticket as any).TAXES[infoTaxeIndex].DL_TAXELIB;
                        }
                    }
                    infosTaxes.push({ DL_CODETAXE: taxe.DL_CODETAXE, T_TAUX: taxe.T_TAUX, T_MONTANT: 0, T_BASE: 0, DL_TAXELIB: taxe.DL_TAXELIB });
                    infoTaxeIndex = infosTaxes.length - 1;
                }
                infosTaxes[infoTaxeIndex].T_MONTANT += taxe.T_MONTANT;
                infosTaxes[infoTaxeIndex].T_BASE += taxe.T_BASE;
            });
        });
        return infosTaxes;
    }

    async doGetPrinterTicketConfig(ticket: CluTickItem, pdossier: any, checkInLocalDb?: boolean) {
        const cloneTicket = Object.assign(new CluTickItem,JSON.parse(JSON.stringify(ticket)));
        let entete: any = cloneTicket.ENTETE;
        let lignes: any[] = cloneTicket.LIGNES;
        if (checkInLocalDb != false) {
            lignes = [];
            for (var i = 0; i < cloneTicket.LIGNES.length; i++) {
                const dbItem = await this._cashDeskRxDbService.db.farticle.findOne({ selector: { $and: [{ "AR_REF": { "$eq": cloneTicket.LIGNES[i].AR_REF } } ] }, sort: [] }).exec();
                if (!!dbItem && dbItem.AR_NOTIMP !== true) {
                    lignes.push(cloneTicket.LIGNES[i]);
                }/* else if (cloneTicket.LIGNES[i].EST_SOUSTOTAL === true) {
                    lignes.push(cloneTicket.LIGNES[i]);
                }*/
            }
        }
        entete.DO_SIGNATURE_NF525 = '';
        if (!!entete.DO_SIGNATURE) {
            const certificateNumber = '(NF525) B0608';
            const payloadSignature = `${(entete.DO_SIGNATURE as string)[2]}${(entete.DO_SIGNATURE as string)[6]}${(entete.DO_SIGNATURE as string)[12]}${(entete.DO_SIGNATURE as string)[18]}`;
            entete.DO_SIGNATURE_NF525 = certificateNumber + ' ' + payloadSignature + ' CLU ' + entete.CLU_APP_VERSION;
        }
        if (!!entete.CL_EXTRAS) {
            try {
                entete.CL_EXTRAS = JSON.parse(entete.CL_EXTRAS);
                Object.keys(entete.CL_EXTRAS).forEach((extraKey: any) => {
                    entete[extraKey] = entete.CL_EXTRAS[extraKey]
                });
            } catch(e) {}
        }


        const tickFamilleItems: any[] = [];
        for (var i = 0; i < lignes.length; i++) {
            const ligne = lignes[i];
            if (!!ligne.CL_EXTRAS) {
                try {
                    lignes[i].CL_EXTRAS = JSON.parse(ligne.CL_EXTRAS);
                    Object.keys(lignes[i].CL_EXTRAS).forEach((extraKey: any) => {
                        lignes[i][extraKey] = lignes[i].CL_EXTRAS[extraKey]
                    });
                } catch(e) {}
            }

            let familleIndex = tickFamilleItems.findIndex(f => f.FA_CODEFAMILLE === ligne.FA_CODEFAMILLE);
            if (familleIndex === -1) {
                const articleLigne = await this.runQuery_doGetArticleItem(ligne.AR_REF!);
                if (!!articleLigne) {
                    tickFamilleItems.push({ FA_CODEFAMILLE: ligne.FA_CODEFAMILLE, FA_INTITULE: articleLigne.FA_FAMNV1LIB ?? ligne.FA_CODEFAMILLE, FA_TOTALTHT: 0, FA_TOTALTTTC: 0 });
                    familleIndex = tickFamilleItems.length - 1;
                }
            }
            if (familleIndex !== -1) {
                tickFamilleItems[familleIndex].FA_TOTALTHT += ligne.DL_MONTANTHT!;
                tickFamilleItems[familleIndex].FA_TOTALTTTC += ligne.DL_MONTANTTTC!;
            }
        }

        let tiersItem: any = null;
        try {
            const doMoreParams = JSON.parse(cloneTicket.ENTETE.DO_MOREPARAMS_JSON);
            tiersItem = doMoreParams.TIERS_ITEM;
        } catch(e) {}
        if (!tiersItem) { tiersItem = {}; }

        return {
            SOCIETE: [pdossier],
            CLIENT: [tiersItem],
            ENTETE: [entete],
            LIGNES: lignes,
            REGLEMENTS: cloneTicket.REGLEMENTS,
            TAXES: await this.GetInfosTaxes([cloneTicket]),
            FAMILLES_ARTICLES: tickFamilleItems,
        };
    }

    private async runQuery_doGetArticleItem(arRef: string) : Promise<RxFArticleDocument | null> {
        return this._cashDeskRxDbService.db.farticle.findOne({
            selector: { AR_REF: { $eq: arRef } },
        }).exec();
    }

    async doGetPrinterDuplicataConfig(ticket: CluTickItem, duplicata: RxCluTickDuplicataDocumentType, pdossier: any, checkInLocalDb?: boolean) {
        const cloneTicket = Object.assign(new CluTickItem,JSON.parse(JSON.stringify(ticket)));
        let entete: any = cloneTicket.ENTETE;
        let lignes: any[] = cloneTicket.LIGNES;
        if (checkInLocalDb != false) {
            lignes = [];
            for (var i = 0; i < cloneTicket.LIGNES.length; i++) {
                const dbItem = await this._cashDeskRxDbService.db.farticle.findOne({ selector: { $and: [{ "AR_REF": { "$eq": cloneTicket.LIGNES[i].AR_REF } } ] }, sort: [] }).exec();
                if (!!dbItem && dbItem.AR_NOTIMP !== true) {
                    lignes.push(cloneTicket.LIGNES[i]);
                }
            }
        }
        entete.DO_SIGNATURE_NF525 = '';
        if (!!entete.DO_SIGNATURE) {
            const certificateNumber = '(NF525) B0608';
            const payloadSignature = `${(entete.DO_SIGNATURE as string)[2]}${(entete.DO_SIGNATURE as string)[6]}${(entete.DO_SIGNATURE as string)[12]}${(entete.DO_SIGNATURE as string)[18]}`;
            entete.DO_SIGNATURE_NF525 = certificateNumber + ' ' + payloadSignature + ' CLU ' + entete.CLU_APP_VERSION;
        }
        entete.DUP_PIECE_INTERNAL = duplicata.DUP_PIECE_INTERNAL;
        entete.DUP_SIGNATURE_NF525 = '';
        if (!!duplicata.DUP_SIGNATURE) {
            const certificateNumber = '(NF525) B0608';
            const payloadSignature = `${(duplicata.DUP_SIGNATURE as string)[2]}${(duplicata.DUP_SIGNATURE as string)[6]}${(duplicata.DUP_SIGNATURE as string)[12]}${(duplicata.DUP_SIGNATURE as string)[18]}`;
            entete.DUP_SIGNATURE_NF525 = certificateNumber + ' ' + payloadSignature + ' CLU ' + entete.CLU_APP_VERSION;
        }
        if (!!entete.CL_EXTRAS) {
            try {
                entete.CL_EXTRAS = JSON.parse(entete.CL_EXTRAS);
                Object.keys(entete.CL_EXTRAS).forEach((extraKey: any) => {
                    entete[extraKey] = entete.CL_EXTRAS[extraKey]
                });
            } catch(e) {}
        }
        lignes.forEach((ligne, index, lignesArray) => {
            if (!!ligne.CL_EXTRAS) {
                try {
                    lignesArray[index].CL_EXTRAS = JSON.parse(ligne.CL_EXTRAS);
                    Object.keys(lignesArray[index].CL_EXTRAS).forEach((extraKey: any) => {
                        lignesArray[index][extraKey] = lignesArray[index].CL_EXTRAS[extraKey]
                    });
                } catch(e) {}
            }
        });

        let oldPDossier: any = null;
        try {
            const DO_MOREPARAMS = JSON.parse(cloneTicket.ENTETE.DO_MOREPARAMS_JSON!);
            oldPDossier = DO_MOREPARAMS['DOSSIER_ITEM'];
        } catch(e) {}
        if (!!oldPDossier) { pdossier = oldPDossier; }

        let tiersItem: any = null;
        try {
            const doMoreParams = JSON.parse(cloneTicket.ENTETE.DO_MOREPARAMS_JSON!);
            tiersItem = doMoreParams.TIERS_ITEM;
        } catch(e) {}
        if (!tiersItem) { tiersItem = {}; }

        return {
            SOCIETE: [pdossier],
            CLIENT: [tiersItem],
            ENTETE: [entete],
            LIGNES: lignes,
            REGLEMENTS: cloneTicket.REGLEMENTS,
            TAXES: await this.GetInfosTaxes([cloneTicket])
        };
    }

    async doGetPrinterGiftcardConfig(ticket: CluTickItem, ligneTicket: any, pdossier: any) {
        return {
            SOCIETE: [pdossier],
            GIFTCARD: [
                {
                    DO_TIERS: ticket.ENTETE.DO_TIERS,
                    DL_GF_CARTE_DESIGNATION: ligneTicket.DL_GF_CARTE_DESIGNATION,
                    DL_GF_CARTE_NUM: ligneTicket.DL_GF_CARTE_NUM,
                    DL_GF_C_TOTAL_TTC_INIT: ligneTicket.DL_GF_C_TOTAL_TTC_INIT,
                    DL_GF_DATE_DEBUT: ligneTicket.DL_GF_DATE_DEBUT,
                    DL_GF_DATE_EXP: ligneTicket.DL_GF_DATE_EXP,
                }
            ]
        };
    }

    async doGetPrinterReturnConfig(returnTicket: CluTickItem, originTicket: CluTickItem, pdossier: any, checkInLocalDb?: boolean) {
        const cloneTicket = Object.assign(new CluTickItem,JSON.parse(JSON.stringify(returnTicket)));
        let entete: any = cloneTicket.ENTETE;
        let lignes: any[] = cloneTicket.LIGNES;
        if (checkInLocalDb != false) {
            lignes = [];
            for (var i = 0; i < cloneTicket.LIGNES.length; i++) {
                const dbItem = await this._cashDeskRxDbService.db.farticle.findOne({ selector: { $and: [{ "AR_REF": { "$eq": cloneTicket.LIGNES[i].AR_REF } } ] }, sort: [] }).exec();
                if (!!dbItem && dbItem.AR_NOTIMP !== true) {
                    lignes.push(cloneTicket.LIGNES[i]);
                }/* else if (cloneTicket.LIGNES[i].EST_SOUSTOTAL === true) {
                    lignes.push(cloneTicket.LIGNES[i]);
                }*/
            }
        }
        entete.DO_SIGNATURE_NF525 = '';
        if (!!entete.DO_SIGNATURE) {
            const certificateNumber = '(NF525) B0608';
            const payloadSignature = `${(entete.DO_SIGNATURE as string)[2]}${(entete.DO_SIGNATURE as string)[6]}${(entete.DO_SIGNATURE as string)[12]}${(entete.DO_SIGNATURE as string)[18]}`;
            entete.DO_SIGNATURE_NF525 = certificateNumber + ' ' + payloadSignature + ' CLU ' + entete.CLU_APP_VERSION;
        }
        if (!!entete.CL_EXTRAS) {
            try {
                entete.CL_EXTRAS = JSON.parse(entete.CL_EXTRAS);
                Object.keys(entete.CL_EXTRAS).forEach((extraKey: any) => {
                    entete[extraKey] = entete.CL_EXTRAS[extraKey]
                });
            } catch(e) {}
        }
        lignes.forEach((ligne, index, lignesArray) => {
            if (!!ligne.CL_EXTRAS) {
                try {
                    lignesArray[index].CL_EXTRAS = JSON.parse(ligne.CL_EXTRAS);
                    Object.keys(lignesArray[index].CL_EXTRAS).forEach((extraKey: any) => {
                        lignesArray[index][extraKey] = lignesArray[index].CL_EXTRAS[extraKey]
                    });
                } catch(e) {}
            }
        });
        let taxes = [];
        if (!!cloneTicket.ENTETE.DO_TAXE_ITEMS_JSON) {
            try { taxes = JSON.parse(cloneTicket.ENTETE.DO_TAXE_ITEMS_JSON); } catch(e) {}
        }

        let tiersItem: any = null;
        try {
            const doMoreParams = JSON.parse(cloneTicket.ENTETE.DO_MOREPARAMS_JSON!);
            tiersItem = doMoreParams.TIERS_ITEM;
        } catch(e) {}
        if (!tiersItem) { tiersItem = {}; }

        return {
            SOCIETE: [pdossier],
            CLIENT: [tiersItem],
            ENTETE: [entete],
            LIGNES: lignes,
            REGLEMENTS: cloneTicket.REGLEMENTS,
            TAXES: taxes
        };
    }

    async doGetPDossier() {
        const dbItem = await this._cashDeskRxDbService.db.pdossier.findOne().exec();
        if (!dbItem) {
            throw "impossible de récupérer les infos société: vérifier la synchronisation des données serveur";
        }

        const pdossier: any = {
            D_RAISONSOC: dbItem.D_RAISONSOC,
            D_PROFESSION: dbItem.D_PROFESSION,
            D_ADRESSE: dbItem.D_ADRESSE,
            D_COMPLEMENT: dbItem.D_COMPLEMENT,
            D_CODEPOSTAL: dbItem.D_CODEPOSTAL,
            D_VILLE: dbItem.D_VILLE,
            D_CODEREGION: dbItem.D_CODEREGION,
            D_PAYS: dbItem.D_PAYS,
            D_EMAIL: dbItem.D_EMAIL,
            D_TELEPHONE: dbItem.D_TELEPHONE,
            D_TELECOPIE: dbItem.D_TELECOPIE,
            D_SITE: dbItem.D_SITE,
            D_SIRET: dbItem.D_SIRET,
            D_APE: dbItem.D_APE,
            D_IDENTIFIANT: dbItem.D_IDENTIFIANT,
            D_RCS: dbItem.D_RCS,
        };

        return pdossier;
    }


    async doGetDefaultModeleImpressionBO(typeModeleImpression: TYPE_MODELE_IMPRESSION) {
        const dbItems = await this.doGetModelesImpressionBO({ TYPE_MODELE_IMPRESSION: typeModeleImpression });
        if (dbItems.length == 0) { return null; }

        return this.doProcessDefaultModeleImpression(dbItems, typeModeleImpression);
    }


    async doGetDefaultModeleImpression(typeModeleImpression: TYPE_MODELE_IMPRESSION, authSessionDto?: AuthSessionDtoFO) {
        const dbItems = await this.doGetModelesImpression({ TYPE_MODELE_IMPRESSION: typeModeleImpression });
        if (dbItems.length == 0) { return null; }

        return this.doProcessDefaultModeleImpression(dbItems, typeModeleImpression, authSessionDto);
    }

    doProcessDefaultModeleImpression(dbItems: any[], typeModeleImpression: TYPE_MODELE_IMPRESSION, authSessionDto?: AuthSessionDtoFO) {
        let userDefinedModeleId: any = null;
        if (!!authSessionDto?.FO_PARAMS?.M_CAISSE_PERM?.CASHIER_ITEM?.DEFAULT_MODELES_IMPRESSION) {
            userDefinedModeleId = authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.DEFAULT_MODELES_IMPRESSION[typeModeleImpression];
        }

        dbItems = dbItems.filter(d => d.TYPE_MODELE_IMPRESSION == typeModeleImpression);

        let defaultModele: any = null;
        if (!!userDefinedModeleId) {
            defaultModele = dbItems.find(d => d.ID == userDefinedModeleId);
        }
        if (defaultModele == null) {
            defaultModele = dbItems.find(d => d.IS_DEFAULT == 1);
        }
        if (defaultModele == null) {
            defaultModele = dbItems[0];
        }
        if (defaultModele == null || !defaultModele.PARAMS_MODELE) { return null; }

        const modele: any = {
            ID: defaultModele.ID,
            LIBELLE: defaultModele.LIBELLE!,
            PARAMS_MODELE: defaultModele.PARAMS_MODELE,
            DATE_CREATION: defaultModele.DATE_CREATION!,
            DATE_MODIFICATION: defaultModele.DATE_MODIFICATION,
            DATE_SUPPRESSION: defaultModele.DATE_SUPPRESSION,
            SOMMEIL: defaultModele.SOMMEIL == 1,
            IS_DEFAULT: defaultModele.IS_DEFAULT == 1,
        };
        return modele;
    }

    async doGetModelesImpressionBO(params?: { TYPE_MODELE_IMPRESSION: TYPE_MODELE_IMPRESSION }) {
        //try {
            let dbItems = await lastValueFrom(this._httpClient.post<DbmPModeleImpression_CashDesk[]>(this._apiService.endPointsBO.doGetModelesImpressionsAction_BOPCashDeskModeleImpression, params));
            if (!!params && params.TYPE_MODELE_IMPRESSION !== undefined) {
                dbItems = dbItems.filter(m => m.TYPE_MODELE_IMPRESSION == params.TYPE_MODELE_IMPRESSION);
            }
            return dbItems;
        /*} catch(error: any) {
            throwError(!!error && !!error.error && !!error.error.Message ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur');
        }*/
    }

    async doGetModelesImpression(params?: { TYPE_MODELE_IMPRESSION: TYPE_MODELE_IMPRESSION }) {
        const whereClauses = [];
        if (!!params && params.TYPE_MODELE_IMPRESSION !== undefined) {
            whereClauses.push({ "TYPE_MODELE_IMPRESSION": { "$eq": params.TYPE_MODELE_IMPRESSION } })
        }
        let queryParams: any = {};
        if (whereClauses.length > 0) {
            queryParams = { selector: { $and: []}, sort: [] };
            queryParams.selector['$and'] = whereClauses;
        }
        const dbItems = await this._cashDeskRxDbService.db.pmodeleimpression.find(queryParams).exec();
        const modeles: any[] = dbItems.map(dbItem => {
            let paramsModele = {};
            try { paramsModele = JSON.parse(dbItem.PARAMS_MODELE!); } catch(e) {}
            if (!paramsModele) { paramsModele = {}; }

            const modele: any = {
                ID: dbItem.ID,
                LIBELLE: dbItem.LIBELLE!,
                PARAMS_MODELE: paramsModele,
                DATE_CREATION: dbItem.DATE_CREATION!,
                DATE_MODIFICATION: dbItem.DATE_MODIFICATION,
                DATE_SUPPRESSION: dbItem.DATE_SUPPRESSION,
                SOMMEIL: dbItem.SOMMEIL == 1,
                IS_DEFAULT: dbItem.IS_DEFAULT == 1,
                TYPE_MODELE_IMPRESSION: dbItem.TYPE_MODELE_IMPRESSION
            };

            return modele;
        });

        return modeles;
    }

    async doGetModeleImpressionByID(_id: string) {
        const dbItem = await this._cashDeskRxDbService.db.pmodeleimpression.findOne({ selector: { $and: [{ "ID": { "$eq": _id } } ] }, sort: [] }).exec();
        if (!dbItem) { return null; }

        let paramsModele = {};
        try { paramsModele = JSON.parse(dbItem.PARAMS_MODELE!); } catch(e) {}
        if (!paramsModele) { paramsModele = {}; }

        const modele: any = {
            ID: dbItem.ID,
            LIBELLE: dbItem.LIBELLE!,
            PARAMS_MODELE: paramsModele,
            DATE_CREATION: dbItem.DATE_CREATION!,
            DATE_MODIFICATION: dbItem.DATE_MODIFICATION,
            DATE_SUPPRESSION: dbItem.DATE_SUPPRESSION,
            SOMMEIL: dbItem.SOMMEIL == 1,
            IS_DEFAULT: dbItem.IS_DEFAULT == 1,
            TYPE_MODELE_IMPRESSION: dbItem.TYPE_MODELE_IMPRESSION
        };

        return modele;
    }

    async checkIfCashdeskShouldOpened(ticket: CluTickItem) {
        if (!ticket.REGLEMENTS) { return false; }

        const modeReglements = await this._cashDeskRxDbService.db.preglement.find().exec();
        const hasEspeceReglement = ticket.REGLEMENTS.find(reglement => {
            const mReglement = modeReglements.find((m: any) => m.CBINDICE == reglement.N_REGLEMENT);
            return !!mReglement && mReglement.ZCD_IS_ESPECE === true;
        });

        return hasEspeceReglement !== undefined;
    }

    async doGetDefaultModeleImpressionRemdocs(typeModeleImpression: REMDOCS_TYPE_DOCUMENT, authSessionDto?: AuthSessionDtoFO) {
        const dbItems = await this.doGetModelesImpressionRemdocs({ TYPE_MODELE_IMPRESSION: typeModeleImpression, TYPE_IMPRESSION: REMDOCS_TYPE_IMPRESSION.STANDARD });
        if (dbItems.length == 0) { return null; }

        return this.doProcessDefaultModeleImpressionRemdocs(dbItems, typeModeleImpression, authSessionDto);
    }

    async doGetDefaultModeleImpressionBTRemdocs(typeModeleImpression: REMDOCS_TYPE_DOCUMENT, authSessionDto?: AuthSessionDtoFO) {
        const dbItems = await this.doGetModelesImpressionRemdocs({ TYPE_MODELE_IMPRESSION: typeModeleImpression, TYPE_IMPRESSION: REMDOCS_TYPE_IMPRESSION.BLUETOOTH });
        if (dbItems.length == 0) { return null; }

        return this.doProcessDefaultModeleImpressionRemdocs(dbItems, typeModeleImpression, authSessionDto);
    }

    private doProcessDefaultModeleImpressionRemdocs(dbItems: any[], typeModeleImpression: REMDOCS_TYPE_DOCUMENT, authSessionDto?: AuthSessionDtoFO) {
        let userDefinedModeleId: any = null;
        /*if (!!authSessionDto?.FO_PARAMS?.M_CAISSE_PERM?.CASHIER_ITEM?.DEFAULT_MODELES_IMPRESSION) {
            userDefinedModeleId = authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.DEFAULT_MODELES_IMPRESSION[typeModeleImpression];
        } */

        let defaultModele: any = null;
        if (!!userDefinedModeleId) {
            defaultModele = dbItems.find(d => d.ID == userDefinedModeleId);
        }
        if (defaultModele == null) {
            defaultModele = dbItems.find(d => d.IS_DEFAULT == 1);
        }
        if (defaultModele == null) {
            defaultModele = dbItems[0];
        }
        if (defaultModele == null || !defaultModele.PARAMS_MODELE) { return null; }

        const modele: any = {
            ID: defaultModele.ID,
            LIBELLE: defaultModele.LIBELLE!,
            PARAMS_MODELE: defaultModele.PARAMS_MODELE,
            DATE_CREATION: defaultModele.DATE_CREATION!,
            DATE_MODIFICATION: defaultModele.DATE_MODIFICATION,
            DATE_SUPPRESSION: defaultModele.DATE_SUPPRESSION,
            SOMMEIL: defaultModele.SOMMEIL == 1,
            IS_DEFAULT: defaultModele.IS_DEFAULT == 1,
            TYPE_MODELE_IMPRESSION: defaultModele.TYPE_MODELE_IMPRESSION,
            TYPE_IMPRESSION: defaultModele.TYPE_IMPRESSION
        };
        return modele;
    }

    async doGetModelesImpressionRemdocs(params?: { TYPE_MODELE_IMPRESSION: REMDOCS_TYPE_DOCUMENT, TYPE_IMPRESSION: REMDOCS_TYPE_IMPRESSION }) {
        const whereClauses = [];
        if (!!params) {
            if (params.TYPE_MODELE_IMPRESSION !== undefined) {
                whereClauses.push({ "TYPE_MODELE_IMPRESSION": { "$eq": params.TYPE_MODELE_IMPRESSION } })
            }
            if (params.TYPE_IMPRESSION !== undefined) {
                whereClauses.push({ "TYPE_IMPRESSION": { "$eq": params.TYPE_IMPRESSION } })
            }
        }
        let queryParams: any = {};
        if (whereClauses.length > 0) {
            queryParams = { selector: { $and: []}, sort: [] };
            queryParams.selector['$and'] = whereClauses;
        }
        const dbItems = await this._remDocsRxDbService.db.pmodeleimpression_remdocs.find(queryParams).exec();
        const modeles: any[] = dbItems.map(dbItem => {
            let paramsModele = {};
            try { paramsModele = JSON.parse(dbItem.PARAMS_MODELE!); } catch(e) {}
            if (!paramsModele) { paramsModele = {}; }

            const modele: any = {
                ID: dbItem.ID,
                LIBELLE: dbItem.LIBELLE!,
                PARAMS_MODELE: paramsModele,
                DATE_CREATION: dbItem.DATE_CREATION!,
                DATE_MODIFICATION: dbItem.DATE_MODIFICATION,
                DATE_SUPPRESSION: dbItem.DATE_SUPPRESSION,
                SOMMEIL: dbItem.SOMMEIL == 1,
                IS_DEFAULT: dbItem.IS_DEFAULT,
                TYPE_MODELE_IMPRESSION: dbItem.TYPE_MODELE_IMPRESSION,
                TYPE_IMPRESSION: dbItem.TYPE_IMPRESSION
            };

            return modele;
        });

        return modeles;
    }

    async doGetPrinterRemDocsConfig(remDoc: CluDocItem, cluDocItemTaxes: CluBilanTaxeItem[], pdossier: any) {
        const clonedRemDoc = Object.assign(new CluDocItem,JSON.parse(JSON.stringify(remDoc)));
        let entete: any = clonedRemDoc.ENTETE;
        let lignes: any[] = clonedRemDoc.LIGNES;

        entete.DO_SIGNATURE_NF525 = '';
        if (!!entete.DO_SIGNATURE) {
            const certificateNumber = '(NF525) B0608';
            const payloadSignature = `${(entete.DO_SIGNATURE as string)[2]}${(entete.DO_SIGNATURE as string)[6]}${(entete.DO_SIGNATURE as string)[12]}${(entete.DO_SIGNATURE as string)[18]}`;
            entete.DO_SIGNATURE_NF525 = certificateNumber + ' ' + payloadSignature + ' CLU ' + entete.CLU_APP_VERSION;
        }
        if (!!entete.CL_EXTRAS) {
            try {
                entete.CL_EXTRAS = JSON.parse(entete.CL_EXTRAS);
                Object.keys(entete.CL_EXTRAS).forEach((extraKey: any) => {
                    entete[extraKey] = entete.CL_EXTRAS[extraKey]
                });
            } catch(e) {}
        }
        lignes.forEach((ligne, index, lignesArray) => {
            if (!!ligne.CL_EXTRAS) {
                try {
                    lignesArray[index].CL_EXTRAS = JSON.parse(ligne.CL_EXTRAS);
                    Object.keys(lignesArray[index].CL_EXTRAS).forEach((extraKey: any) => {
                        lignesArray[index][extraKey] = lignesArray[index].CL_EXTRAS[extraKey]
                    });
                } catch(e) {}
            }
        });

        return {
            SOCIETE: [pdossier],
            ENTETE: [entete],
            LIGNES: lignes,
            REGLEMENTS: clonedRemDoc.REGLEMENTS,
            ECHEANCES: clonedRemDoc.ECHEANCES,
            TAXES: cluDocItemTaxes
        };
    }

    async doGetPDossierRemDocs() {
        const dbItem = await this._remDocsRxDbService.db.pdossier.findOne().exec();
        if (!dbItem) {
            throw "impossible de récupérer les infos société: vérifier la synchronisation des données serveur";
        }

        const pdossier: any = {
            D_RAISONSOC: dbItem.D_RAISONSOC,
            D_PROFESSION: dbItem.D_PROFESSION,
            D_ADRESSE: dbItem.D_ADRESSE,
            D_COMPLEMENT: dbItem.D_COMPLEMENT,
            D_CODEPOSTAL: dbItem.D_CODEPOSTAL,
            D_VILLE: dbItem.D_VILLE,
            D_CODEREGION: dbItem.D_CODEREGION,
            D_PAYS: dbItem.D_PAYS,
            D_EMAIL: dbItem.D_EMAIL,
            D_TELEPHONE: dbItem.D_TELEPHONE,
            D_TELECOPIE: dbItem.D_TELECOPIE,
            D_SITE: dbItem.D_SITE,
            D_SIRET: dbItem.D_SIRET,
            D_APE: dbItem.D_APE,
            D_IDENTIFIANT: dbItem.D_IDENTIFIANT,
            D_RCS: dbItem.D_RCS,
        };

        return pdossier;
    }
}
